export default __webpack_public_path__ + "static/media/tick.abb5382e.svg";